{
  "header": {
    "nav": {
      "solutions": "Solutions",
      "developers": "Développeurs",
      "contact": "Contact"
    },
    "signIn": "Se connecter",
    "getStarted": "Commencer",
    "goToDashboard": "Aller au tableau de bord",
    "openMenu": "Ouvrir le menu principal"
  },
  "hero": {
    "title": "Gérez votre entreprise de services",
    "titleHighlight": "sans effort",
    "subtitle": "La plateforme tout-en-un pour planifier les rendez-vous, gérer les clients, suivre les revenus et développer votre activité. Commencez gratuitement, évoluez facilement.",
    "startTrial": "Essai gratuit",
    "seeHowItWorks": "Voir comment ça marche"
  },
  "features": {
    "title": "Tout ce dont vous avez besoin pour réussir",
    "subtitle": "Des fonctionnalités puissantes pour gagner du temps, augmenter vos revenus et offrir une expérience client exceptionnelle.",
    "items": {
      "scheduling": {
        "name": "Planification intelligente",
        "description": "Une prise de rendez-vous intelligente qui réduit les absences et optimise votre agenda."
      },
      "customers": {
        "name": "Gestion des clients",
        "description": "Suivez l'historique, les préférences et les interactions de vos clients en un seul endroit."
      },
      "analytics": {
        "name": "Tableau de bord analytique",
        "description": "Obtenez des insights sur vos performances avec des analyses et rapports en temps réel."
      },
      "payments": {
        "name": "Traitement des paiements",
        "description": "Acceptez les paiements facilement avec un traitement intégré et la facturation."
      },
      "reminders": {
        "name": "Rappels automatiques",
        "description": "Réduisez les absences grâce aux rappels automatiques par e-mail et SMS."
      },
      "security": {
        "name": "Sécurisé et fiable",
        "description": "Sécurité de niveau entreprise avec une disponibilité garantie à 99,9 %."
      },
      "mobile": {
        "name": "Prêt pour mobile",
        "description": "Gérez votre activité en déplacement avec une expérience entièrement responsive."
      },
      "booking": {
        "name": "Réservation en ligne",
        "description": "Permettez à vos clients de réserver en ligne 24 h/24 via votre page personnalisée."
      }
    }
  },
  "testimonials": {
    "title": "Apprécié par les entreprises partout",
    "subtitle": "Découvrez ce que nos clients disent de leur expérience avec Woezor.",
    "items": {
      "sarah": {
        "content": "Woezor a transformé notre gestion des rendez-vous. Notre taux d'absence a chuté de 60 % dès le premier mois !",
        "role": "Propriétaire, Serenity Spa"
      },
      "michael": {
        "content": "Le tableau de bord analytique m'offre des insights que je n'avais jamais eus. Je peux enfin prendre des décisions basées sur les données.",
        "role": "Directeur, Family Health Clinic"
      },
      "emily": {
        "content": "La configuration a été incroyablement simple. En un jour, la réservation en ligne était opérationnelle et les clients réservaient déjà.",
        "role": "Responsable, Elite Fitness Studio"
      },
      "james": {
        "content": "Le support client est exceptionnel. Ils nous ont aidés à tout personnaliser selon notre flux de travail.",
        "role": "Fondateur, Wilson Consulting"
      },
      "lisa": {
        "content": "Nous avons augmenté nos réservations de 40 % depuis le passage à Woezor. Le retour sur investissement est incroyable.",
        "role": "Propriétaire, Park Beauty Lounge"
      },
      "david": {
        "content": "Enfin un système de planification qui fonctionne vraiment pour les entreprises de services. Je recommande vivement !",
        "role": "PDG, Thompson Home Services"
      }
    }
  },
  "cta": {
    "title": "Prêt à transformer votre entreprise ?",
    "subtitle": "Rejoignez des milliers d'entreprises de services qui font confiance à Woezor pour gérer leurs rendez-vous, clients et croissance. Commencez votre essai gratuit aujourd'hui.",
    "getStarted": "Commencer gratuitement",
    "talkToSales": "Parler aux ventes",
    "benefits": {
      "trial": "Essai gratuit de 14 jours",
      "noCard": "Aucune carte bancaire requise",
      "cancel": "Annulation à tout moment"
    }
  },
  "footer": {
    "company": "Entreprise",
    "product": "Produit",
    "legal": "Mentions légales",
    "connect": "Réseaux",
    "about": "À propos",
    "contact": "Contact",
    "features": "Fonctionnalités",
    "pricing": "Tarifs",
    "privacy": "Politique de confidentialité",
    "terms": "Conditions d'utilisation",
    "twitter": "Twitter",
    "linkedin": "LinkedIn",
    "copyright": "© {{year}} ForumOne. Tous droits réservés."
  },
  "solutions": {
    "heroTitle": "Des solutions pour chaque entreprise",
    "heroSubtitle": "Découvrez comment Woezor peut transformer votre activité avec des outils puissants conçus pour gagner du temps, augmenter vos revenus et satisfaire vos clients.",
    "items": {
      "appointments": {
        "title": "Gestion des rendez-vous",
        "description": "Simplifiez vos réservations avec notre système de planification intelligent. Réduisez les absences et optimisez votre agenda.",
        "features": {
          "portal": "Portail de réservation en ligne",
          "reminders": "Rappels automatiques",
          "sync": "Synchronisation calendrier",
          "recurring": "Rendez-vous récurrents"
        }
      },
      "customers": {
        "title": "Gestion des clients",
        "description": "Renforcez vos relations clients. Suivez interactions, préférences et historique en un seul endroit.",
        "features": {
          "profiles": "Profils clients",
          "history": "Historique des interactions",
          "notes": "Notes et étiquettes",
          "segmentation": "Segmentation"
        }
      },
      "analytics": {
        "title": "Analyses et insights",
        "description": "Prenez des décisions basées sur les données grâce à des analyses complètes. Comprenez vos performances en un coup d'œil.",
        "features": {
          "revenue": "Suivi des revenus",
          "trends": "Tendances de réservation",
          "insights": "Insights clients",
          "reports": "Rapports personnalisés"
        }
      },
      "payments": {
        "title": "Traitement des paiements",
        "description": "Acceptez les paiements facilement. Plusieurs moyens de paiement, facturation automatique et suivi financier.",
        "features": {
          "methods": "Plusieurs moyens de paiement",
          "invoicing": "Facturation automatique",
          "reminders": "Rappels de paiement",
          "reports": "Rapports financiers"
        }
      },
      "notifications": {
        "title": "Notifications et alertes",
        "description": "Tenez tout le monde informé. Notifications automatiques pour rendez-vous, mises à jour et événements importants.",
        "features": {
          "email": "Notifications e-mail",
          "sms": "Rappels SMS",
          "push": "Notifications push",
          "triggers": "Déclencheurs personnalisés"
        }
      },
      "security": {
        "title": "Sécurité et conformité",
        "description": "Vos données sont en sécurité. Sécurité de niveau entreprise et conformité aux normes du secteur.",
        "features": {
          "encryption": "Chiffrement des données",
          "access": "Accès basé sur les rôles",
          "audit": "Journaux d'audit",
          "gdpr": "Conforme RGPD"
        }
      }
    },
    "industriesTitle": "Conçu pour votre secteur",
    "industriesSubtitle": "Que vous soyez praticien solo ou que vous gériez plusieurs sites, Woezor s'adapte à vos besoins.",
    "industries": {
      "healthcare": {
        "title": "Santé",
        "description": "Cabinets médicaux, cliniques et prestataires de santé"
      },
      "beauty": {
        "title": "Beauté et bien-être",
        "description": "Salons, spas et centres de bien-être"
      },
      "professional": {
        "title": "Services professionnels",
        "description": "Consultants, avocats et comptables"
      },
      "fitness": {
        "title": "Fitness",
        "description": "Salles de sport, coachs et studios fitness"
      },
      "education": {
        "title": "Éducation",
        "description": "Tuteurs, coachs et centres de formation"
      },
      "home": {
        "title": "Services à domicile",
        "description": "Nettoyage, réparations et maintenance"
      }
    },
    "ctaTitle": "Prêt à transformer votre entreprise ?",
    "ctaSubtitle": "Rejoignez des milliers d'entreprises qui utilisent déjà notre plateforme pour grandir.",
    "startTrial": "Essai gratuit",
    "contactSales": "Contacter les ventes"
  },
  "contact": {
    "heroTitle": "Contactez-nous",
    "heroSubtitle": "Des questions sur Woezor ? Vous souhaitez une démo ? Notre équipe est là pour vous aider à trouver la solution idéale pour votre entreprise.",
    "formTitle": "Envoyez-nous un message",
    "formDescription": "Remplissez le formulaire ci-dessous et nous vous répondrons dès que possible.",
    "name": "Nom",
    "email": "E-mail",
    "company": "Entreprise",
    "message": "Message",
    "namePlaceholder": "Votre nom",
    "emailPlaceholder": "vous@exemple.com",
    "companyPlaceholder": "Votre entreprise (facultatif)",
    "messagePlaceholder": "Comment pouvons-nous vous aider ?",
    "send": "Envoyer le message",
    "sending": "Envoi en cours…",
    "success": "Message envoyé ! Nous vous répondrons bientôt.",
    "errors": {
      "nameRequired": "Le nom est requis",
      "emailRequired": "L'e-mail est requis",
      "emailInvalid": "Veuillez saisir une adresse e-mail valide",
      "messageRequired": "Le message est requis"
    },
    "infoTitle": "Coordonnées",
    "infoSubtitle": "Contactez-nous via l'un de ces canaux.",
    "channels": {
      "email": {
        "title": "E-mail",
        "description": "Notre équipe répond sous 24 heures"
      },
      "phone": {
        "title": "Téléphone",
        "description": "Lun–ven de 8 h à 18 h"
      },
      "office": {
        "title": "Bureau",
        "description": "Venez nous rendre visite"
      },
      "hours": {
        "title": "Horaires",
        "description": "Heures d'ouverture",
        "value": "Lun – ven : 8 h – 18 h"
      }
    },
    "faqTitle": "Questions fréquentes",
    "faqDescription": "Vous cherchez des réponses rapides ? Consultez notre FAQ pour les questions courantes sur les tarifs, les fonctionnalités et la prise en main.",
    "viewFaq": "Voir la FAQ →"
  },
  "developers": {
    "badge": "Plateforme développeur",
    "heroTitle": "Développez avec l'API Woezor",
    "heroSubtitle": "Intégrez la planification de rendez-vous, la gestion des clients et bien plus dans vos applications grâce à notre API et nos outils développeur.",
    "viewDocs": "Voir la documentation",
    "getApiKeys": "Obtenir les clés API",
    "featuresTitle": "Conçu pour les développeurs",
    "featuresSubtitle": "Tout ce dont vous avez besoin pour intégrer Woezor dans vos applications.",
    "features": {
      "rest": {
        "title": "API RESTful",
        "description": "API REST claire et bien documentée pour une intégration fluide avec vos systèmes existants."
      },
      "oauth": {
        "title": "OAuth 2.0",
        "description": "Authentification sécurisée via le protocole OAuth 2.0 standard du secteur."
      },
      "json": {
        "title": "Réponses JSON",
        "description": "Format de réponse JSON cohérent avec une gestion complète des erreurs."
      },
      "webhooks": {
        "title": "Webhooks",
        "description": "Notifications d'événements en temps réel pour synchroniser vos systèmes."
      },
      "rateLimit": {
        "title": "Limitation de débit",
        "description": "Politiques d'utilisation équitable avec des limites généreuses pour tous les plans."
      },
      "uptime": {
        "title": "99,9 % de disponibilité",
        "description": "Infrastructure fiable avec des garanties de haute disponibilité."
      }
    },
    "codeTitle": "Simple et intuitif",
    "codeSubtitle": "Démarrez en quelques minutes grâce à notre API claire. Créez des rendez-vous, gérez les clients et accédez aux analyses en quelques lignes de code.",
    "steps": {
      "signup": {
        "title": "Créez un compte",
        "description": "Créez votre compte développeur gratuit"
      },
      "keys": {
        "title": "Obtenez vos clés API",
        "description": "Générez des clés depuis votre tableau de bord"
      },
      "build": {
        "title": "Commencez à développer",
        "description": "Effectuez votre premier appel API"
      }
    },
    "sdksTitle": "SDK officiels",
    "sdksSubtitle": "Utilisez nos SDK officiels pour intégrer Woezor dans votre langage préféré.",
    "sdkStatus": {
      "stable": "stable",
      "beta": "bêta",
      "coming": "bientôt"
    },
    "ctaTitle": "Prêt à commencer à développer ?",
    "ctaSubtitle": "Créez votre compte gratuit et obtenez vos clés API en quelques minutes.",
    "getStarted": "Commencer gratuitement",
    "talkToSales": "Parler aux ventes"
  }
}
